import { bannerSlider } from "@omni/ui/brand/bannerSlider/bannerSlider.styles";
import { Mapped } from "@omni/utils/context/mapped.context";
import { ReactNode } from "react";

import { useBannerSliderContext } from "../../../../context/bannerSlider.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { slides } = useBannerSliderContext();

    if (slides.length < 2) {
        return null;
    }

    const { controls_progressBar } = bannerSlider();

    return (
        <div className={controls_progressBar({ className: className })}>
            <Mapped array={slides}>{children}</Mapped>
        </div>
    );
};
